import React from "react";
import intl from "react-intl-universal";
import {observer} from "mobx-react-lite";
import {useRootStore, useUserState} from "@stores/AppStateContext";

import {GroupIcon} from "../../../../components/icons/GroupIcon";
import {UserAvatar} from "../../../../components/Avatar/Avatar";
import {ActiveUserBadge} from "./ActiveUsersBadge";
import {getFullName} from "../../../../../utils/userHelper";

import {getDocPath} from "@stores/ActivityProvider";

import {screenSizeProvider} from "@stores/ScreenSizeProvider";


import "../ActivUsers/ActiveUsers.css"


export const ActiveUserCount = observer(() => {
    const rootStore = useRootStore();
    const userState = useUserState();
    const selectedNode = rootStore.view.workspace!.selected;

    if (!selectedNode) {
        return null;
    }

    const currentDocActivity = userState!.activityProvider!.activity.get(getDocPath(rootStore.view.workspace!.id, selectedNode.id));
    const activeUsersCount = currentDocActivity ? currentDocActivity.size : 0;

    return (
        <div>
            <div className='ActiveUsers-count headline-large-bold'>
                {activeUsersCount}
            </div>
        </div>
    );
});

export const ActiveUsers = observer(() => {
    const isMobile = screenSizeProvider.view !== 'desktop';
    const rootStore = useRootStore();
    const userState = useUserState();
    const selectedNode = rootStore.view.workspace!.selected;

    if (!selectedNode) {
        return null;
    }

    const activity = userState!.activityProvider!.activity;
    const currentDocActivity = activity.get(getDocPath(rootStore.view.workspace!.id, selectedNode.id)) || new Set();

    return (
        <div className="ActiveUsers">
            {
                !isMobile ? (
                    <div className="ActiveUsers-header">
                        <div className={'ActiveUsers-title body-large'}>
                            {intl.get('activeUsers.sub_header').d('Users currently viewing this Page:')}
                        </div>
                        <ActiveUserCount/>
                        <div className="ActiveUsersIcon">
                            <GroupIcon size={20}/>
                        </div>
                    </div>
                ) : null
            }
            <div className='ActiveUsers__content'>
                {
                    currentDocActivity.size === 0 && isMobile
                        ? (
                            <div className={'ActiveUsers-empty'}>
                                {intl.get('activeUsers.empty').d('No users are currently viewing this page.')}
                            </div>
                        ) : (
                            Array.from(currentDocActivity).map((userId: string) => {
                                const user = userState!.usersDS.users.get(userId);
                                if (!user) {
                                    return null;
                                }
                                return (
                                    <div className="ActiveUsers__name-block" key={userId}>
                                        <ActiveUserBadge>
                                            <UserAvatar
                                                user={user}
                                                size={36}
                                            />
                                        </ActiveUserBadge>
                                        <div className='ActiveUsers__name body-large'>
                                            {user ? getFullName(user) : userId}
                                        </div>
                                    </div>
                                );
                            })
                        )
                }
            </div>
        </div>
    );
});
